import { Button as AntButton, ButtonProps } from "antd";
import styled from "styled-components";

export const Button: typeof AntButton = styled(AntButton)<ButtonProps>`
  &.ant-btn-primary {
    background: #981202;
    border-color: #981202;
    &:focus,
    &:hover {
      background: #981202;
      border-color: #981202;
      color: #fff;
    }
  }
`;
